(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const mobileMenuToggle = document.querySelector('.mobile-menu__toggle');
    mobileMenuToggle.addEventListener('click', () => {
      const body = document.querySelector('body');
      body.classList.toggle('mobile-menu--open');
    });
    const mobileMenuToggleClose = document.querySelector('.mobile-menu__toggle--close');
    mobileMenuToggleClose.addEventListener('click', () => {
      const body = document.querySelector('body');
      body.classList.toggle('mobile-menu--open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-size-selector] .size-option');
    if (!button) return;

    const form = button.closest('form');
    const variantInput = form.querySelector('[data-variant-id]');

    variantInput.value = button.dataset.variantId;

    form.querySelectorAll('.size-option').forEach((option) => {
      option.classList.remove('is-selected');
    });

    button.classList.add('is-selected');
  });

  let swiper;

  function initSwiper() {
    swiper?.destroy();
    if (typeof Swiper === 'undefined' || !document.querySelector('.swiper')) return;

    swiper = new Swiper('.swiper', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  function initAccordion(toggle, panel, openIconSelector, closeIconSelector) {
    if (!toggle || !panel) return;

    const openIcon = toggle.querySelector(openIconSelector);
    const closeIcon = toggle.querySelector(closeIconSelector);

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      const isOpen = panel.classList.toggle('is-open');
      openIcon.classList.toggle('hidden', isOpen);
      closeIcon.classList.toggle('hidden', !isOpen);
    });
  }

  function initAccordions() {
    initAccordion(
      document.querySelector('[data-fabric-care-toggle]'),
      document.querySelector('[data-fabric-care-panel]'),
      '.fabric-care-title-icon-open',
      '.fabric-care-title-icon-close'
    );
    initAccordion(
      document.querySelector('[data-size-guide-toggle]'),
      document.querySelector('[data-size-guide-panel]'),
      '.size-guide-title-icon-open',
      '.size-guide-title-icon-close'
    );
  }

  initSwiper();
  document.addEventListener('DOMContentLoaded', initAccordions);

  // A colour swatch swapped in another product's section (see color-swatches.liquid)
  document.addEventListener('product:replaced', function () {
    initSwiper();
    initAccordions();
  });

  } catch(e) { console.error(e); }
})();
})();
